import { PhoneNumbers, CountryTypes } from 'src/Routes/Service/Contact/contact-models'
import { CountryCodes } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { UserLevel } from 'src/State/User/UserModel'

export const supportPhoneNumbers: PhoneNumbers = {
  [CountryCodes.GERMANY]: {
    private: '+49 541 93213210',
    business: '+49 541 93213210',
  },
  [CountryCodes.SWITZERLAND]: {
    private: '+41 41 269 96 95',
    business: '+41 41 269 96 99',
  },
  [CountryCodes.NETHERLANDS]: {
    private: '+31 73 6428584',
    business: '+31 73 6428584',
  },
  INTERNATIONAL: {
    private: '+49 541 760268367',
    business: '+49 541 760268352',
  },
}

export const supportEmails = {
  [CountryCodes.GERMANY]: 'support@e3dc.com',
  [CountryCodes.SWITZERLAND]: 'support.ch@e3dc.com',
  [CountryCodes.NETHERLANDS]: 'support@e3dc.com',
}

export const supportOpeningHours = {
  moTh: '08:00 - 17:00',
  fr: '08:00 - 15:00',
}

export const allowedCountries: CountryTypes[] = [CountryCodes.SWITZERLAND, CountryCodes.GERMANY, CountryCodes.NETHERLANDS]

export const allowedUserLevels: UserLevel[] = ['USER', 'PARTNER', 'INSTALLER']
